"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalMessageButtonHandler = exports.EModalMessageButtonType = void 0;
exports.ModalMessage = ModalMessage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var message_dialog_1 = require("../../features/thunks/message-dialog");
var hooks_1 = require("../../store/hooks");
var EModalMessageButtonType;
(function (EModalMessageButtonType) {
    EModalMessageButtonType["OK"] = "ok";
    EModalMessageButtonType["CANCEL"] = "cancel";
})(EModalMessageButtonType || (exports.EModalMessageButtonType = EModalMessageButtonType = {}));
var modalMessageButtonHandler = (_a = {},
    _a[EModalMessageButtonType.OK] = function () { },
    _a[EModalMessageButtonType.CANCEL] = function () { },
    _a);
exports.modalMessageButtonHandler = modalMessageButtonHandler;
function ModalMessage() {
    var _a = (0, hooks_1.useAppSelector)(function (state) { return state.messageDialog; }), isOpen = _a.isOpen, header = _a.header, body = _a.body, buttons = _a.buttons;
    var dispatch = (0, hooks_1.useAppDispatch)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, disableAnimation: true, onOpenChange: function (isOpen) {
                if (!isOpen) {
                    dispatch((0, message_dialog_1.closeMessageDialogThunk)());
                }
            }, children: (0, jsx_runtime_1.jsx)(react_1.ModalContent, { children: function (onClose) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.ModalHeader, { className: "flex flex-col gap-1", children: header !== null && header !== void 0 ? header : "No Header" }), (0, jsx_runtime_1.jsx)(react_1.ModalBody, { children: (0, jsx_runtime_1.jsx)("div", { children: body !== null && body !== void 0 ? body : "No Body" }) }), (0, jsx_runtime_1.jsx)(react_1.ModalFooter, { children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function (button, index) { return ((0, jsx_runtime_1.jsx)(react_1.Button, { variant: button.variant, onPress: function () {
                                    modalMessageButtonHandler[button.type]();
                                    onClose();
                                }, children: button.label }, index)); }) })] })); } }) }) }));
}
